import { gql } from '@apollo/client'

export const CancelInvite = gql`
    mutation CancelInvite($inviteId: ID!) {
        cancelInvite(inviteId: $inviteId)
    }
`

export default CancelInvite

